// import React from 'react';
import App from '../pageComponents/App';
// import whyDidYouRender from '@welldone-software/why-did-you-render';

// if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
//   whyDidYouRender(React);
// }

export default App;
